import { Component } from "./Component";
import { GameObject } from "./GameObject";

export class SpineAnimator extends Component {
	protected _spine: SpineGameObject;
	protected _spineContainer: SpineContainer;
	// Used to pause and resume spine animation
	private timeScale = 1;

	static ANIMATION_COMPLETE = "complete";

	get spine(): SpineGameObject {
		return this._spine;
	}
	get spineContainer(): SpineContainer {
		return this._spineContainer;
	}

	constructor(obj: GameObject, config: SpineGameObjectConfig) {
		super(obj);
		this._spine = obj.scene.make.spine(config);
		this._spineContainer = obj.scene.add.spineContainer(0, 0, this._spine);
		this.obj.add(this._spineContainer);
		this.setFlipX(config.flipX ? config.flipX : false);
	}

	play(animationName: string, loop?: boolean, ignoreIfPlaying?: boolean): void {
		this._spine.play(animationName, loop, ignoreIfPlaying);
	}

	setVisible(visible: boolean): void {
		this._spine.visible = visible;
	}

	setSpineScale(scale: number): void {
		this._spine.setScale(scale, scale);
	}

	getSpineScale(): number {
		return this._spine.scale;
	}

	setFlipX(flipX: boolean): void {
		const x = flipX ? -this._spine.scaleX : this._spine.scaleX;
		this._spine.setScale(x, this.spine.scaleY);
	}

	pause(): void {
		this.timeScale = this._spine.timeScale;
		this._spine.timeScale = 0;
	}

	resume(): void {
		this._spine.timeScale = this.timeScale;
		this._spine.timeScale = 1;
	}
}
